import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="bg-background-100 py-10 md:py-14" aria-labelledby="updates-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 id="updates-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            最近更新
          </h2>
          <Link
            to="/category/danmei"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
          >
            全部更新
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {latestUpdates.map((update) => (
            <Link
              key={`${update.comicId}-${update.chapter}`}
              to={`/comic/${update.comicId}`}
              className="flex items-center gap-3 p-3 md:p-4 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                  {update.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{update.chapter}</p>
              </div>
              <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{update.time}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}